(function () {
  if (window.__sintcoOfferBadge) return;
  window.__sintcoOfferBadge = true;

  var DISCOUNT_API = "https://aiod.cirkleinc.com/api/display-discount-table";
  var CACHE_MS = 5 * 60 * 1000;
  var PRIORITY = { gift: 0, bogo: 1, volume: 2, wholesale: 3, bundle: 4 };
  var cache = null;
  var cacheAt = 0;
  var paintQueued = false;

  function shopDomain() {
    var shopify = window.Shopify || {};
    return shopify.shop || "";
  }

  function currencyCode() {
    var shopify = window.Shopify || {};
    return (shopify.currency && shopify.currency.active) || "CAD";
  }

  function countryCode() {
    var shopify = window.Shopify || {};
    return shopify.country || "CA";
  }

  function i18n() {
    var node = document.getElementById("sintco-offer-badge-i18n");
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  }

  function interpolate(template, vars) {
    var out = String(template || "");
    Object.keys(vars || {}).forEach(function (key) {
      out = out.split("{{ " + key + " }}").join(String(vars[key]));
      out = out.split("{{" + key + "}}").join(String(vars[key]));
    });
    return out;
  }

  function fetchTable(requestType) {
    var params = new URLSearchParams({
      shop: shopDomain(),
      request_type: String(requestType),
      currency: currencyCode(),
      country: countryCode(),
    });
    return fetch(DISCOUNT_API + "?" + params.toString(), { credentials: "omit" })
      .then(function (response) {
        if (!response.ok) throw new Error("discount-" + requestType);
        return response.json();
      })
      .catch(function () {
        return { data: [] };
      });
  }

  function productIdsFrom(row, key) {
    return ((row && row[key]) || [])
      .map(function (product) {
        return product && product.product_id != null ? String(product.product_id) : "";
      })
      .filter(Boolean);
  }

  function getProductIds(row) {
    var ids = productIdsFrom(row, "products_get");
    if (ids.length) return ids;
    return productIdsFrom(row, "gift_products");
  }

  function isActive(row) {
    return row && String(row.status) === "1";
  }

  function remember(map, productId, offer) {
    if (!productId) return;
    var current = map[productId];
    if (!current || PRIORITY[offer.type] < PRIORITY[current.type]) {
      map[productId] = offer;
    }
  }

  function classifyBogo(row) {
    var buyIds = productIdsFrom(row, "products");
    var otherGet = getProductIds(row).some(function (id) {
      return buyIds.indexOf(id) === -1;
    });
    if (otherGet) return "gift";
    return "bogo";
  }

  function indexBuyProducts(map, row, type) {
    if (!isActive(row)) return;
    var buyIds = productIdsFrom(row, "products");
    if (!buyIds.length) return;
    var qty = parseInt(row.bogo_quantity_buy || row.quantity_buy || row.quantity, 10) || 0;
    buyIds.forEach(function (id) {
      remember(map, id, { type: type, qty: qty });
    });
  }

  function indexRows(map, rows, type) {
    (rows || []).forEach(function (row) {
      indexBuyProducts(map, row, type);
    });
  }

  function buildIndex(payloads) {
    var map = {};
    ((payloads[0] && payloads[0].data) || []).forEach(function (row) {
      indexBuyProducts(map, row, classifyBogo(row));
    });
    indexRows(map, (payloads[1] && payloads[1].data) || [], "volume");
    indexRows(map, (payloads[2] && payloads[2].data) || [], "wholesale");
    indexRows(map, (payloads[3] && payloads[3].data) || [], "bundle");
    return map;
  }

  function loadIndex() {
    var now = Date.now();
    if (cache && now - cacheAt < CACHE_MS) return Promise.resolve(cache);
    if (!shopDomain()) return Promise.resolve({});
    return Promise.all([fetchTable(3), fetchTable(1), fetchTable(2), fetchTable(0)]).then(function (payloads) {
      cache = buildIndex(payloads);
      cacheAt = Date.now();
      return cache;
    });
  }

  function labelsFor(offer, copy) {
    var type = offer && offer.type;
    var chip = copy["chip_" + type] || copy.chip_offer || "";
    var teaser = copy["teaser_" + type] || copy.teaser_offer || "";
    if (type === "bogo" && offer.qty > 1 && copy.teaser_bogo_qty) {
      teaser = interpolate(copy.teaser_bogo_qty, { qty: offer.qty });
    }
    return { chip: chip, teaser: teaser };
  }

  function showNode(node, text) {
    if (!node) return;
    if (!text) {
      node.hidden = true;
      node.classList.remove("is-visible");
      node.textContent = "";
      return;
    }
    node.textContent = text;
    node.hidden = false;
    node.classList.add("is-visible");
  }

  function paint(map, copy) {
    var nodes = document.querySelectorAll("[data-sintco-offer-badge]");
    var grouped = {};
    Array.prototype.forEach.call(nodes, function (node) {
      var id = String(node.getAttribute("data-product-id") || "");
      if (!id) return;
      if (!grouped[id]) grouped[id] = { chip: [], teaser: [] };
      var part = node.getAttribute("data-offer-part") === "teaser" ? "teaser" : "chip";
      grouped[id][part].push(node);
    });

    Object.keys(grouped).forEach(function (id) {
      var offer = map[id];
      var parts = grouped[id];
      if (!offer) {
        parts.chip.forEach(function (node) {
          showNode(node, "");
        });
        parts.teaser.forEach(function (node) {
          showNode(node, "");
        });
        return;
      }
      var labels = labelsFor(offer, copy);
      parts.chip.forEach(function (node) {
        showNode(node, labels.chip);
      });
      parts.teaser.forEach(function (node) {
        showNode(node, labels.teaser);
      });
    });
  }

  function refresh() {
    if (paintQueued) return;
    paintQueued = true;
    window.requestAnimationFrame(function () {
      paintQueued = false;
      loadIndex().then(function (map) {
        paint(map, i18n());
      });
    });
  }

  function observe() {
    if (!document.body) return;
    var observer = new MutationObserver(function (mutations) {
      var found = false;
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (found || node.nodeType !== 1) return;
          if (node.matches && node.matches("[data-sintco-offer-badge]")) found = true;
          else if (node.querySelector && node.querySelector("[data-sintco-offer-badge]")) found = true;
        });
      });
      if (found) refresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      refresh();
      observe();
    });
  } else {
    refresh();
    observe();
  }
})();
